<template>
  <section
    class="message__split-bar"
    :class="{
      'message__split-bar--new': message.newMessages
    }"
    :data-new-message-bar="message.newMessages"
  >
    <strong class="split-bar__message">
      {{ message.content }}
    </strong>
  </section>
</template>

<script>
export default {
  props: {
    message: { type: Object, required: true }
  }
}
</script>

<style lang="scss">
@import '@/style/_non-rendering';
.message__split-bar {
  position: sticky;
  text-align: center;
  top: -8px;
  background-color: var(--split-bar-background-color);
  z-index: 3;
  margin-left: -16px;
  margin-right: -16px;

  .message:first-child & {
    margin-top: 0;
  }

  &::before {
    background-color: var(--split-bar-border-color);
    bottom: 0;
    content: '';
    height: 1px;
    left: 0;
    margin: auto;
    position: absolute;
    right: 0;
    top: 0;
  }

  .split-bar__message {
    @extend %overline-small;
    background-color: var(--split-bar-background);
    border-radius: var(--gl-border-radius-lg);
    color: var(--split-bar-color);
    padding: var(--gl-spacing-01) var(--gl-spacing-04);
    position: relative;
    z-index: 1;
    display: inline;
  }

  &--new {
    --split-bar-background: var(--gl-color-shades-gray-90);
    --split-bar-color: var(--gl-color-shades-white);
    --split-bar-border-color: var(--split-bar-background);
    position: relative;
    z-index: 0;
    top: 0;
  }
}
</style>
